import {CP_API_TESTNET, NETWORKS} from "../const/general";
import { ethers } from "ethers";
import { tokenABI } from "../abis/erc20.js";
import {TOKENS} from "../const/tokens";
const { ethereum } = window;

export const isMetaMaskInstalled = () => Boolean(ethereum && ethereum.isMetaMask);

export const connectEthereumWallet = async (currency) => {
  if (!isMetaMaskInstalled())  return null;

  const address = await ethereum
    .request({ method: "eth_requestAccounts" })
    .then((accounts) => accounts[0]);

  await ethereum
    .request({ method: "eth_chainId" })
    .then((chainId) => {
      const chainNumber = parseInt(Number(chainId));
      if (NETWORKS.ETH[CP_API_TESTNET ? 'TESTNET' : 'MAINNET'].CHAIN !== chainNumber) {
        return changeEthereumNetwork(address, currency);
      }
    });

  return getEthereumBalance(address, currency);
};

export const getEthereumWallet = async (currency) => {
  if (!isMetaMaskInstalled())  return null;

  const address = await ethereum
    .request({ method: "eth_accounts" })
    .then((accounts) => accounts[0]);

  await ethereum
    .request({ method: "eth_chainId" })
    .then((chainId) => {
      const chainNumber = parseInt(Number(chainId));
      if (NETWORKS.ETH[CP_API_TESTNET ? 'TESTNET' : 'MAINNET'].CHAIN !== chainNumber) {
        return changeEthereumNetwork(address, currency);
      }
    });

  return getEthereumBalance(address, currency);
};

export const getEthereumBalance = async (account, tokenName) => {
  if (!isMetaMaskInstalled())  return null;

  let balance;

  if (tokenName === NETWORKS.ETH[CP_API_TESTNET ? 'TESTNET' : 'MAINNET'].SYMBOL) {
    balance = !account ? 0 : await ethereum
      .request({
        method: "eth_getBalance",
        params: [account, "latest"]
      })
      .then((balance) => ethers.formatEther(balance));
  } else {
    const provider = new ethers.BrowserProvider(ethereum);
    const tokenContract = new ethers.Contract(
      TOKENS[tokenName][CP_API_TESTNET ? 'TESTNET' : 'MAINNET'].address,
      tokenABI,
      provider
    );
    const tokenBalance = await tokenContract.balanceOf(account);
    const decimals = await tokenContract.decimals();
    balance = Number(tokenBalance / BigInt(10**Number(decimals)));
  }

  return { address: account, balance }
};

export const changeEthereumNetwork = async (address, currency) => {
  try {
    await ethereum.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId: ethers.toQuantity(NETWORKS.ETH[CP_API_TESTNET ? 'TESTNET' : 'MAINNET'].CHAIN) }],
    }).then(() => getEthereumBalance(address, currency));
  } catch (switchError) {
    if (switchError.code === 4902) {
      // You can make a request to add the chain to wallet here
      addEthereumNetwork(address, currency);
    }
  }
};

export const addEthereumNetwork = async (address, currency) => {
  try {
    await ethereum.request({
      method: 'wallet_addEthereumChain',
      params: [{
        chainId: ethers.toQuantity(NETWORKS.ETH[CP_API_TESTNET ? 'TESTNET' : 'MAINNET'].CHAIN),
        rpcUrls: [NETWORKS.ETH[CP_API_TESTNET ? 'TESTNET' : 'MAINNET'].RPC],
        chainName: NETWORKS.ETH[CP_API_TESTNET ? 'TESTNET' : 'MAINNET'].NAME,
        nativeCurrency: {
          name: NETWORKS.ETH[CP_API_TESTNET ? 'TESTNET' : 'MAINNET'].SYMBOL,
          symbol: NETWORKS.ETH[CP_API_TESTNET ? 'TESTNET' : 'MAINNET'].SYMBOL,
          decimals: 18
        },
        blockExplorerUrls: [NETWORKS.ETH[CP_API_TESTNET ? 'TESTNET' : 'MAINNET'].EXPLORER]
      }],
    }).then(() => getEthereumBalance(address, currency));
  } catch (error) {
    throw(error);
  }
};

export const ethereumCreateTransaction = async (from, to, value, currency) => {
  if (!isMetaMaskInstalled())  return null;

  try {
    if (currency === NETWORKS.ETH[CP_API_TESTNET ? 'TESTNET' : 'MAINNET'].SYMBOL) {
      await ethereum.request({
        method: 'eth_sendTransaction',
        params: [
          {
            from,
            to: to,
            value: ethers.toQuantity(ethers.parseUnits(String(value), "ether")),
          },
        ],
      });
      //   .then(res => {
      //   return res;
      // });
    } else {
      const iFace = new ethers.Interface(tokenABI);
      const txData = iFace.encodeFunctionData("transfer", [
        to,
        ethers.toQuantity(
          ethers.parseUnits(String(value),
          Number(TOKENS[currency][CP_API_TESTNET ? 'TESTNET' : 'MAINNET'].decimals,
        )))
      ]);

      await ethereum.request({
        method: 'eth_sendTransaction',
        params: [
          {
            from,
            to: TOKENS[currency][CP_API_TESTNET ? 'TESTNET' : 'MAINNET'].address,
            value: '0x0',
            data: txData
          },
        ],
      });
    }
  } catch (error) {
    throw(error)
  }
};

